import { toParamString } from "../utils/UrlUtility";
import { doFetch, doPostFetch } from "./apiFetchHelper";
import { t } from "@lingui/core/macro";

const geoSearchURL = "/api/geosearch";

export const findGeoLocations = ({ phrase }) =>
  doFetch(`${geoSearchURL}?${toParamString({ phrase })}`);

export const getRecentLocations = () => doFetch(`${geoSearchURL}/history`);

export const postRecentLocation = ({ lat, lon, name }) =>
  doPostFetch(`${geoSearchURL}/history`, { lat, lon, name });

// Helpers

export const getGeoLocationByZipOrPhrase = (phrase, callback) => {
  findGeoLocations({ phrase })
    .then((locationsRes) => {
      if (locationsRes.length > 0) {
        callback(locationsRes[0], null);
      } else {
        const warnString = t`The zip code or phrase: ${phrase} returned 0 results`;
        console.warn(warnString);
        callback(null, warnString);
      }
    })
    .catch((err) => console.log(err));
};

export const getIpLocation = () => doFetch(`${geoSearchURL}/iplookup`);
